// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-approver__fields[data-v-26ec054b] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.search-approver-department__container[data-v-26ec054b] {
  background-color: #f5f5f5;
  border: solid 1px #adadad;
  border-radius: 4px;
}
.search-approver-department__container .pui-form-input-field[data-v-26ec054b] {
  border: none;
  padding: 0;
  margin: 0;
}
.search-approver-department__container .pui-form-input-field .pui-form-input-field__input[data-v-26ec054b] {
  padding: 0;
}
.search-approver-department__container .search-approver__subtitle[data-v-26ec054b] {
  padding-left: 2px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
